import axios, { AxiosResponse } from 'axios'
import {
  AtendimentoView,
  AtendimentoPacienteQueryResponse,
  AtendimentosQueryResponse,
  CIDQueryResponse,
  EstadosDeAtendimentoQueryResponse,
  PendenciaAso,
  TipoASO,
  TipoAtendimentoEmpresa,
  ArquivoDto,
  AtendimentoDtoInformacaoAgrupada,
  AtendimentoDtoCreate,
  AtendimentoDto,
  AtendimentoDtoDadosAso,
  AtendimentoDtoAnotacao,
  AtendimentoDtoCid,
  EstadoAtendimentoDto,
  AtendimentoEsusContexto,
  InterrupcaoAtendimentoDtoCreate,
  InterrupcaoAtendimentoView,
  TranscricaoAtendimentoView,
  TelekitDispositivoDicom,
  DicomJsonObjeto,
  ExamesImagemAtendimento,
  ResultadoSolicitacaoExameImagem,
  SolicitacaoExameImagem,
} from './_models'
import {
  AsoType,
  AtendimentoEstado,
  AtendimentoType,
  ID,
  ISituacaoAso,
  Response,
} from '../../../../../_metronic/helpers'
import { Prescricao } from '../../atendimento_medicos/memed/_models'
import {
  AtendimentoDtoProcedimento,
  AtendimentoDtoProcedimentoUpdate,
} from '../../atendimento_medicos/atendimentos-medico-list/core/_models'
import { EnderecoList } from '../../empresa/empresas-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTO_URL = `${API_URL}/atendimentos`
const CID_URL = `${API_URL}/cid`
const FATOR_RISCO_URL = `${API_URL}/fatoresRisco`
const TIPOS_URL = `${API_URL}/tipos`
const ESTADOS_URL = `${ATENDIMENTO_URL}/estados`
const ATENDIMENTO_FILA_URL = `${API_URL}/atendimentos/empresa/`
const ATENDIMENTO_FILA_PACIENTE_URL = `${API_URL}/atendimentos/empresa/paciente/`
const ATENDIMENTO_PACIENTE_URL = `${API_URL}/atendimentos/paciente`
const ATENDIMENTO_ANOTACAO_URL = `${API_URL}/atendimentos/anotacao`
const ATENDIMENTO_PENDENTE_URL = `${API_URL}/atendimentos/pendente`
const ATENDIMENTO_CID_URL = `${API_URL}/atendimentos/cid`
const ATENDIMENTO_DOWNLOAD_URL = `${API_URL}/atendimentos/download`
const ATENDIMENTO_COMPROVANTE_ACEITE_URL = `${API_URL}/atendimentos/comprovante-aceite`
const ATENDIMENTO_FATOR_RISCO_URL = `${API_URL}/atendimentos/fatorRisco`
const ATENDIMENTO_ENDERECOS_URL = `${API_URL}/empresas/endereco/atendimento`
const ATENDIMENTO_PROCEDIMENTO_URL = `${API_URL}/atendimentos/procedimento`
const ATENDIMENTO_PROCEDIMENTO_ANEXO_URL = `${API_URL}/atendimentos/procedimento/anexo`
const ATENDIMENTO_PROCEDIMENTO_MULTI_ANEXOS_URL = `${API_URL}/atendimentos/procedimento/anexos`
const ATENDIMENTO_INFORMACAO_URL = `${API_URL}/atendimentos//informacao`

export function iniciarAtendimento(idPacienteEmpresa: string, tipo: string, tipoAso?: string) {
  return axios.post(ATENDIMENTO_PACIENTE_URL, {
    paciente: idPacienteEmpresa,
    tipo: tipo,
    tipoAso: tipoAso,
  })
}

export function iniciarAtendimentoPaciente(
  idPacienteEmpresa: string,
  tipo: AtendimentoType,
  tipoAso?: AsoType
) {
  return axios.post(`${ATENDIMENTO_PACIENTE_URL}/${idPacienteEmpresa}`, {
    tipo: tipo,
    tipoAso: tipoAso,
  })
}

export function iniciarAtendimentoProfissional(
  idPacienteEmpresa: string,
  tipo: string,
  data?: string
) {
  return axios.post(`${ATENDIMENTO_URL}/${idPacienteEmpresa}`, {
    tipo: tipo,
    data: data !== '' ? data : null,
  })
}
/**
 * Agenda um atendimento para o paciente.
 * @param idPaciente - identificador do paciente
 * @param atendimento - objeto AtendimentoDtoCreate
 * @returns Retorna o AtendimentoDto
 */
export const agendaAtendimento = (
  idPaciente: number,
  atendimento: AtendimentoDtoCreate
): Promise<AtendimentoDto> => {
  return axios
    .post(`${ATENDIMENTO_URL}/agenda/${idPaciente}`, atendimento)
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

export const getAtendimentosOfPaciente = (
  query: string
): Promise<AtendimentoPacienteQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_PACIENTE_URL}?${query}`)
    .then((d: AxiosResponse<AtendimentoPacienteQueryResponse>) => d.data)
}
export const getAtendimentosMedico = (query: string): Promise<AtendimentosQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_URL}/?${query}`)
    .then((d: AxiosResponse<AtendimentosQueryResponse>) => d.data)
}

export const getAtendimentosMedicoLogado = (query: string): Promise<AtendimentosQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_URL}/profissional?${query}`)
    .then((d: AxiosResponse<AtendimentosQueryResponse>) => d.data)
}

/**
 * PDF da teleconsultoria (interconsulta): mesmo contrato de `downloadRelatorioAtendimento`.
 * Disponível com a interconsulta CONCLUIDA ou AVALIADA (422 antes disso); pode vir protegido com o
 * CPF do paciente, como os demais PDFs.
 */
export const downloadRelatorioTeleconsultoria = (idAtendimento: ID): Promise<ArquivoDto> => {
  return axios
    .get(`${ATENDIMENTO_URL}/interconsulta/${idAtendimento}/pdf`)
    .then((d: AxiosResponse<ArquivoDto>) => d.data)
}

export const getAtendimentosRelatorio = (id: string): Promise<AtendimentosQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_URL}/empresa/${id}`)
    .then((d: AxiosResponse<AtendimentosQueryResponse>) => d.data)
}

/**
 * Download do relatório de atendimento
 * @param idAtendimento ID do Atendimento
 * @returns ArquivoDto
 */
export const downloadRelatorioAtendimento = (idAtendimento: ID): Promise<ArquivoDto> => {
  return axios
    .get(`${ATENDIMENTO_DOWNLOAD_URL}/${idAtendimento}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

export const alteraAtendimentoASO = (
  atendimentoId: ID,
  atendimento: AtendimentoDtoDadosAso
): Promise<AtendimentoDto | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/aso/${atendimentoId}`, atendimento)
    .then((response: AxiosResponse<AtendimentoDto>) => response.data)
}
export const getCIDs = (query: string): Promise<CIDQueryResponse> => {
  return axios.get(`${CID_URL}?${query}`).then((d: AxiosResponse<CIDQueryResponse>) => d.data)
}
/**
 * Busca os atendimentos do paciente
 * @param idPaciente Identificador do paciente
 * @param query string
 * @returns AtendimentoPacienteList
 */
export const getAtendimentosByPaciente = (
  idPaciente: ID,
  query: string
): Promise<AtendimentoPacienteQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_FILA_PACIENTE_URL}${idPaciente}?${query}`)
    .then((d: AxiosResponse<AtendimentoPacienteQueryResponse>) => d.data)
}

export const getAtendimentosEmpresaAguardando = (
  idEmpresa: string,
  query: string
): Promise<AtendimentosQueryResponse> => {
  const queryWithoutFilter0 = query.replace(/&?filter_0=\d*/, '')
  return axios
    .get(`${ATENDIMENTO_FILA_URL}${idEmpresa}?${queryWithoutFilter0}`)
    .then((d: AxiosResponse<AtendimentosQueryResponse>) => d.data)
}
/**
 * Busca um atendimento
 * @param id Identificador do atendimento
 * @returns AtendimentoView
 */
export const getAtendimentoById = (id: ID): Promise<AtendimentoView> => {
  return axios
    .get(`${ATENDIMENTO_URL}/${id}`)
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}

/**
 * Cancela um atendimento com o motivo tipado do catálogo do backend.
 *
 * O código e o detalhamento vão em campos separados — o backend deriva a classe do motivo e
 * recusa código desconhecido, motivo de uso exclusivo do sistema e "Outros" sem detalhamento.
 * @param id Identificador do atendimento
 * @param motivoCodigo Código do catálogo (ex.: `FALTA_ENERGIA`)
 * @param motivoDetalhe Detalhamento livre; obrigatório quando o código é `OUTROS`
 */
export const cancelarAtendimentoById = (
  id: ID,
  motivoCodigo: string,
  motivoDetalhe?: string
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/cancela/${id}`, { motivoCodigo, motivoDetalhe })
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}

/**
 * Marca falta em um atendimento com o motivo tipado do catálogo do backend.
 *
 * O código e o detalhamento vão em campos separados — o backend deriva a classe do motivo e
 * recusa código desconhecido, motivo de uso exclusivo do sistema e "Outros" sem detalhamento.
 * @param id Identificador do atendimento
 * @param motivoCodigo Código do catálogo (ex.: `PACIENTE_NAO_COMPARECEU`)
 * @param motivoDetalhe Detalhamento livre; obrigatório quando o código é `OUTROS`
 */
export const faltaAtendimentoById = (
  id: ID,
  motivoCodigo: string,
  motivoDetalhe?: string
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/falta/${id}`, { motivoCodigo, motivoDetalhe })
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}
export const marcarPresenca = (id: ID): Promise<AtendimentoView | undefined> => {
  return axios
    .patch(`${ATENDIMENTO_URL}/paciente/${id}`)
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}
export const marcarPresencaPaciente = (id: ID): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/presenca/${id}`)
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}
export const reabrirAtendimentoById = (
  id: ID,
  observacao: string
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/reabre/${id}`, { observacao })
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}
export const getTiposAtendimentosByPaciente = (id: ID) => {
  return axios
    .get<TipoAtendimentoEmpresa[]>(`${ATENDIMENTO_PACIENTE_URL}/${id}/tipos`)
    .then((response: AxiosResponse<TipoAtendimentoEmpresa[]>) => response.data)
}
export const generateAso = (idAtendimento: ID) => {
  return axios
    .put<ArquivoDto>(`${ATENDIMENTO_URL}/aso/generate/${idAtendimento}`)
    .then((response: AxiosResponse<ArquivoDto>) => response.data)
}
export const downloadAso = (idAtendimento: ID) => {
  return axios
    .get<ArquivoDto>(`${ATENDIMENTO_URL}/aso/download/${idAtendimento}`)
    .then((response: AxiosResponse<ArquivoDto>) => response.data)
}

/**
 * Busca o comprovante de aceite do termo de consentimento do atendimento
 * @param idAtendimento Identificador do atendimento
 * @returns ArquivoDto com o PDF autenticado do aceite; a requisição rejeita com 404 quando o
 * atendimento não possui aceite registrado ou comprovante gerado
 */
export const getComprovanteAceite = (idAtendimento: ID): Promise<ArquivoDto> => {
  return axios
    .get(`${ATENDIMENTO_COMPROVANTE_ACEITE_URL}/${idAtendimento}`)
    .then((response: AxiosResponse<ArquivoDto>) => response.data)
}

/**
 * Download de anexo de atendimento
 * @param idAtendimento Identificador do atendimendo
 * @param idAnexo Identificador do anexo
 * @param somenteUrl Flag para retornar somente a URL do arquivo, sem o conteúdo em base64
 * @returns ArquivoDto
 */
export const downloadAnexo = (idAtendimento: ID, idAnexo: ID, somenteUrl: boolean = false) => {
  return axios
    .get<ArquivoDto>(
      `${ATENDIMENTO_DOWNLOAD_URL}/${idAtendimento}/${idAnexo}?somenteUrl=${somenteUrl}`
    )
    .then((response: AxiosResponse<ArquivoDto>) => response.data)
}

export const getInformacoesAtendimentoById = (
  id: ID
): Promise<AtendimentoDtoInformacaoAgrupada[] | undefined> => {
  return axios
    .get(`${ATENDIMENTO_INFORMACAO_URL}/${id}`)
    .then((response: AxiosResponse<AtendimentoDtoInformacaoAgrupada[]>) => response.data)
}
export const getAtendimentoPacienteById = (id: ID): Promise<AtendimentoView | undefined> => {
  return axios
    .get(`${ATENDIMENTO_PACIENTE_URL}/${id}`)
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}
export function getEstadosDeAtendimento(): Promise<EstadosDeAtendimentoQueryResponse> {
  return axios
    .get(ESTADOS_URL)
    .then((d: AxiosResponse<EstadosDeAtendimentoQueryResponse>) => d.data)
}

/**
 * Busca todos os estados de atendimentos ativos (cache)
 * @returns EstadoAtendimentoDto
 */
export const getEstadosAtendimentoWithCache = (): Promise<EstadoAtendimentoDto[]> => {
  return axios
    .get(`${ESTADOS_URL}/ativos`)
    .then((d: AxiosResponse<EstadoAtendimentoDto[]>) => d.data)
}

export const getTiposResultadoASO = () => {
  return axios
    .get<TipoASO[]>(`${TIPOS_URL}/aso/resultado`)
    .then((d: AxiosResponse<TipoASO[]>) => d.data)
}
export const getTiposASO = () => {
  return axios.get(`${TIPOS_URL}/aso`).then((resp: AxiosResponse<TipoASO[]>) => resp.data)
}
export const getTiposFatorASO = () => {
  return axios.get<TipoASO[]>(`${FATOR_RISCO_URL}`).then((d: AxiosResponse<TipoASO[]>) => d.data)
}
export const getSituacaoesAso = () => {
  return axios
    .get(`${API_URL}/tipos/aso/situacao`)
    .then((d: AxiosResponse<ISituacaoAso[]>) => d.data)
}
/**
 * Contexto e-SUS do encerramento (E1d): se a integração está ativa na unidade do atendimento, as
 * lotações elegíveis para o carimbo e a lista fechada de condutas.
 *
 * Autorizado por `Atendimento:read` — a mesma permissão do `GET /atendimentos/{id}` —, então quem
 * encerra o atendimento consegue ler. O tenant é resolvido no backend pelo próprio atendimento:
 * nenhum `empresaId` sai daqui.
 */
export const getContextoEsusEncerramento = (
  idAtendimento: ID
): Promise<AtendimentoEsusContexto> => {
  return axios
    .get(`${ATENDIMENTO_URL}/${idAtendimento}/esus-encerramento`)
    .then((response: AxiosResponse<AtendimentoEsusContexto>) => response.data)
}

/**
 * Altera o atendimento (usado tanto no início quanto no encerramento).
 *
 * `lotacao` e `condutas` são opcionais e do bloco e-SUS do encerramento: as chaves só entram no
 * corpo quando o valor é definido. Ausente (`undefined`) não é o mesmo que vazio — o backend recusa
 * `condutas: []` com 422 ("Informe ao menos uma conduta"), enquanto a ausência do campo deixa o
 * default server-side agir. O campo do corpo chama-se `lotacao` (não `lotacaoId`): nome errado é
 * descartado em silêncio e o atendimento encerra sem carimbo.
 */
export const alteraAtendimento = (
  idAtendimento: ID,
  estado: AtendimentoEstado,
  responsavel: Number,
  salaVideo: boolean,
  cid: Number | null,
  lotacao?: number | null,
  condutas?: number[]
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/${idAtendimento}`, {
      estado,
      responsavel,
      salaVideo,
      cid,
      ...(lotacao !== undefined && { lotacao }),
      ...(condutas !== undefined && { condutas }),
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}

/**
 *
 * @param atendimentoId ID do atendimento
 * @param cidId ID do cid
 * @returns void
 */
export const deleteCid = (atendimentoId: ID, cidId: ID): Promise<void> => {
  return axios.delete(`${ATENDIMENTO_CID_URL}/${atendimentoId}?idCid=${cidId}`)
}

/**
 * Adiciona CID a um atendimento
 * @param atendimentoId ID do atendimento
 * @param data AtendimentoDtoCid
 * @returns AtendimentoDto
 */
export const adicionarCid = (
  atendimentoId: number,
  data: AtendimentoDtoCid
): Promise<AtendimentoDto> => {
  return axios
    .put(`${ATENDIMENTO_CID_URL}/${atendimentoId}`, data)
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

export const alteraEmpresaClienteAtendimento = (
  idAtendimento: ID,
  cliente: ID,
  pcmso?: ID
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/${idAtendimento}`, {
      cliente: cliente,
      pcmso: pcmso ? pcmso : null,
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}
export const vinculaResponsavelPcmso = (
  idAtendimento: ID,
  colaboradorId: ID
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/${idAtendimento}`, {
      pcmso: colaboradorId,
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}
export const alteraTipoAso = (
  idAtendimento: ID,
  tipoAso: string
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/${idAtendimento}`, {
      tipoAso: tipoAso,
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}
export const informaResultado = (
  idAtendimento: ID,
  resultado: string
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/${idAtendimento}`, {
      resultado: resultado,
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}
export const adicionaProcedimento = (
  idAtendimento: ID,
  data: String,
  nome: String,
  descricao: String
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_PROCEDIMENTO_URL}/${idAtendimento}`, {
      data,
      nome,
      descricao,
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}

export const editarProcedimento = (
  idAtendimento: ID,
  procedimento: AtendimentoDtoProcedimentoUpdate
): Promise<AtendimentoView | undefined> => {
  return axios
    .patch(`${ATENDIMENTO_PROCEDIMENTO_URL}/${idAtendimento}`, procedimento)
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}

export const adicionarProcedimento = (
  idAtendimento: ID,
  procedimento: AtendimentoDtoProcedimento
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_PROCEDIMENTO_URL}/${idAtendimento}`, procedimento)
    .then((response: AxiosResponse<AtendimentoView>) => response.data)
}

export const deleteProcedimento = (atendimentoId: ID, procedimentoId: ID): Promise<void> => {
  return axios.delete(
    `${ATENDIMENTO_PROCEDIMENTO_URL}/${atendimentoId}?idProcedimento=${procedimentoId}`
  )
}
export const adicionaFatorRisco = (
  idAtendimento: ID,
  fatorRisco: String,
  valor: String
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_FATOR_RISCO_URL}/${idAtendimento}`, {
      fatorRisco,
      valor,
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}
export const editarFatorRisco = (
  idAtendimento: ID,
  idFatorRisco: ID,
  fatorRisco: String,
  valor: String
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_FATOR_RISCO_URL}/${idAtendimento}`, {
      id: idFatorRisco,
      fatorRisco,
      valor,
    })
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}
export const deleteFatorRisco = (atendimentoId: ID, fatorRiscoId: ID): Promise<void> => {
  return axios.delete(
    `${ATENDIMENTO_FATOR_RISCO_URL}/${atendimentoId}?idFatorRisco=${fatorRiscoId}`
  )
}
export const validateAso = (idAtendimento: ID): Promise<PendenciaAso | undefined> => {
  return axios
    .get(`${ATENDIMENTO_URL}/aso/validate/${idAtendimento}`)
    .then((response: AxiosResponse<Response<PendenciaAso>>) => response.data)
    .then((response: Response<PendenciaAso>) => response.data)
}
export const adicionaPrescricao = (
  idAtendimento: ID,
  prescricao: Prescricao
): Promise<AtendimentoView | undefined> => {
  return axios
    .put(`${ATENDIMENTO_URL}/prescricao/${idAtendimento}`, prescricao)
    .then((response: AxiosResponse<Response<AtendimentoView>>) => response.data)
    .then((response: Response<AtendimentoView>) => response.data)
}

/**
 * Adiciona anotação a um atendimento
 * @param idAtendimento Identificador do atendimento
 * @param data AtendimentoDtoAnotacao
 * @returns AtendimentoDto
 */
export const adicionarAnotacao = (
  idAtendimento: number,
  data: AtendimentoDtoAnotacao
): Promise<AtendimentoDto> => {
  return axios
    .put(`${ATENDIMENTO_ANOTACAO_URL}/${idAtendimento}`, data)
    .then((response: AxiosResponse<AtendimentoDto>) => response.data)
}

export const deleteAnotacao = (atendimentoId: ID, anotacaoId: ID): Promise<void> => {
  return axios.delete(`${ATENDIMENTO_ANOTACAO_URL}/${atendimentoId}?idAnotacao=${anotacaoId}`)
}
export const deleteAtendimento = (atendimentoId: ID): Promise<void> => {
  return axios.delete(`${ATENDIMENTO_URL}/${atendimentoId}`)
}
export const deleteSelectedAtendimento = (atendimentoIds: Array<ID>): Promise<void> => {
  const requests = atendimentoIds.map((id) => axios.delete(`${ATENDIMENTO_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export const registerPendencia = (observacao: string, atendimentoId: ID): Promise<void> => {
  return axios.put(`${ATENDIMENTO_PENDENTE_URL}/${atendimentoId}`, { observacao })
}

export const resolvePendencia = (observacao: string, atendimentoId: ID): Promise<void> => {
  return axios.patch(`${ATENDIMENTO_PENDENTE_URL}/${atendimentoId}`, { observacao })
}

/**
 * Busca endereços de atendimento
 * @param atendimentoId Identificador do atendimento
 * @returns EnderecoList[]
 */
export const getEnderecosByAtendimento = (atendimentoId: number): Promise<EnderecoList[]> => {
  return axios
    .get(`${ATENDIMENTO_ENDERECOS_URL}/${atendimentoId}`)
    .then((resp: AxiosResponse<EnderecoList[]>) => resp.data)
}

/**
 * Adiciona procedimento/exame a um atendimento
 * @param atendimentoId Identificador do atendimento
 * @param dto Procedimento/exame - AtendimentoDtoProcedimento
 * @param file File
 * @returns AtendimentoDto
 */
export const createProcedimentoWithAnexo = (
  atendimentoId: number,
  dto: AtendimentoDtoProcedimento,
  file: File
): Promise<AtendimentoDto> => {
  const formData = new FormData()
  formData.append('dto', JSON.stringify(dto))
  formData.append('file', file)

  return axios
    .put(`${ATENDIMENTO_PROCEDIMENTO_ANEXO_URL}/${atendimentoId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

/**
 * Adiciona procedimento/exame a um atendimento
 * @param atendimentoId Identificador do atendimento
 * @param dto Procedimento/exame - AtendimentoDtoProcedimento
 * @param file File
 * @returns AtendimentoDto
 */
export const updateProcedimentoWithAnexo = (
  atendimentoId: number,
  dto: AtendimentoDtoProcedimento,
  file: File
): Promise<AtendimentoDto> => {
  const formData = new FormData()
  formData.append('dto', JSON.stringify(dto))
  formData.append('file', file)

  return axios
    .patch(`${ATENDIMENTO_PROCEDIMENTO_ANEXO_URL}/${atendimentoId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

/**
 * Adiciona arquivos a um procedimento/exame a um atendimento
 * @param atendimentoId
 * @param dto Procedimento/exame - AtendimentoDtoProcedimento
 * @param files File[]
 * @returns AtendimentoDto
 */
export const createProcedimentosWithAnexo = (
  atendimentoId: number,
  dto: AtendimentoDtoProcedimento,
  files: File[]
): Promise<AtendimentoDto> => {
  const formData = new FormData()
  formData.append('dto', JSON.stringify(dto))

  files.forEach((file) => {
    formData.append('files', file)
  })

  return axios
    .put(`${ATENDIMENTO_PROCEDIMENTO_MULTI_ANEXOS_URL}/${atendimentoId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

/**
 * Altera arquivos a um procedimento/exame a um atendimento
 * @param atendimentoId
 * @param dto Procedimento/exame - AtendimentoDtoProcedimento
 * @param files File[]
 * @returns AtendimentoDto
 */
export const updateProcedimentosWithAnexo = (
  atendimentoId: number,
  dto: AtendimentoDtoProcedimento,
  files: File[]
): Promise<AtendimentoDto> => {
  const formData = new FormData()
  formData.append('dto', JSON.stringify(dto))

  files.forEach((file) => {
    formData.append('files', file)
  })

  return axios
    .patch(`${ATENDIMENTO_PROCEDIMENTO_MULTI_ANEXOS_URL}/${atendimentoId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

export const addMensagem = (idAtendimento: ID, mensagem: string): Promise<AtendimentoDto> => {
  return axios
    .put(`${ATENDIMENTO_URL}/mensagem/${idAtendimento}`, { mensagem })
    .then((resp: AxiosResponse<AtendimentoDto>) => resp.data)
}

/**
 * Declara uma interrupção ocorrida durante a teleconsulta.
 *
 * Registro append-only e independente do encerramento: falhar aqui nunca pode
 * impedir o profissional de finalizar o atendimento.
 */
export const declararInterrupcao = (
  atendimentoId: ID,
  dto: InterrupcaoAtendimentoDtoCreate
): Promise<InterrupcaoAtendimentoView> => {
  return axios
    .post(`${ATENDIMENTO_URL}/${atendimentoId}/interrupcoes`, dto)
    .then((resp: AxiosResponse<InterrupcaoAtendimentoView>) => resp.data)
}

export const getInterrupcoesAtendimento = (
  atendimentoId: ID
): Promise<InterrupcaoAtendimentoView[]> => {
  return axios
    .get(`${ATENDIMENTO_URL}/${atendimentoId}/interrupcoes`)
    .then((resp: AxiosResponse<InterrupcaoAtendimentoView[]>) => resp.data)
}

export const getTranscricoesAtendimento = (
  idAtendimento: ID
): Promise<TranscricaoAtendimentoView[]> =>
  axios
    .get(`${ATENDIMENTO_URL}/${idAtendimento}/transcricoes`)
    .then((resp: AxiosResponse<TranscricaoAtendimentoView[]>) => resp.data)

// ---- Exames de imagem DICOM ----

/** Pageable do backend é 0-based; 100 cobre os 99 pedidos possíveis por atendimento. */
const EXAMES_IMAGEM_PAGINA = 'page=0&size=100'

export const getDispositivosExameImagem = (
  idAtendimento: ID
): Promise<TelekitDispositivoDicom[]> => {
  return axios
    .get(`${ATENDIMENTO_URL}/${idAtendimento}/exames-imagem/dispositivos?${EXAMES_IMAGEM_PAGINA}`)
    .then((resp: AxiosResponse<Response<TelekitDispositivoDicom[]>>) => resp.data.data ?? [])
}

export const getExamesImagemAtendimento = (idAtendimento: ID): Promise<ExamesImagemAtendimento> => {
  return axios
    .get(`${ATENDIMENTO_URL}/${idAtendimento}/exames-imagem?${EXAMES_IMAGEM_PAGINA}`)
    .then((resp: AxiosResponse<ExamesImagemAtendimento>) => resp.data)
}

export const solicitarExameImagem = (
  idAtendimento: ID,
  idTelekitDispositivo: number
): Promise<ResultadoSolicitacaoExameImagem> => {
  return axios
    .post(`${ATENDIMENTO_URL}/${idAtendimento}/exames-imagem`, { idTelekitDispositivo })
    .then((resp: AxiosResponse<SolicitacaoExameImagem>) => ({
      criada: resp.status === 201,
      solicitacao: resp.data,
    }))
}

export const cancelarSolicitacaoExameImagem = (
  idAtendimento: ID,
  idSolicitacao: number
): Promise<SolicitacaoExameImagem> => {
  return axios
    .patch(`${ATENDIMENTO_URL}/${idAtendimento}/exames-imagem/${idSolicitacao}/cancelar`)
    .then((resp: AxiosResponse<SolicitacaoExameImagem>) => resp.data)
}

const DICOMWEB_URL = `${API_URL}/dicomweb/atendimentos`
const ACEITA_DICOM_JSON = { Accept: 'application/dicom+json' }

/** QIDO do estudo antes de abrir o viewer; corpo vazio (204) vira lista vazia. */
export const getPreChecagemEstudoDicom = (
  idAtendimento: ID,
  studyInstanceUid: string
): Promise<DicomJsonObjeto[]> => {
  return axios
    .get(`${DICOMWEB_URL}/${idAtendimento}/studies`, {
      params: { StudyInstanceUID: studyInstanceUid },
      headers: ACEITA_DICOM_JSON,
    })
    .then((resp: AxiosResponse<DicomJsonObjeto[] | ''>) =>
      Array.isArray(resp.data) ? resp.data : []
    )
}

export const getMiniaturaEstudoDicom = (
  idAtendimento: ID,
  studyInstanceUid: string
): Promise<Blob> => {
  return axios
    .get(`${DICOMWEB_URL}/${idAtendimento}/studies/${studyInstanceUid}/thumbnail`, {
      responseType: 'blob',
      headers: { Accept: 'image/jpeg' },
    })
    .then((resp: AxiosResponse<Blob>) => resp.data)
}

export const getMetadataEstudoDicom = (
  idAtendimento: ID,
  studyInstanceUid: string
): Promise<DicomJsonObjeto[]> => {
  return axios
    .get(`${DICOMWEB_URL}/${idAtendimento}/studies/${studyInstanceUid}/metadata`, {
      headers: ACEITA_DICOM_JSON,
    })
    .then((resp: AxiosResponse<DicomJsonObjeto[] | ''>) =>
      Array.isArray(resp.data) ? resp.data : []
    )
}
